'use strict';

/**
 * Model for a conversation
 *
 * @category   Model
 * @module     community
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Model = require('base/Colido.Model');
var ConversationPostsCollection = require('../collections/conversationPosts');

var ConversationModel = Model.extend({
    api: '/community/conversations',

    cacheCustomAttributes: false,

    defaults: function(){ //use function, cause objects are passed by reference
        return {
            type: 'contact', //String [contact|group|broadcast]
            referenceId: null, //Integer
            creatorId: null, //Integer
            public: false, //Boolean
            posts: [], //Array
            unreadPosts: 0, //Integer
            lastMessage: null, //String
            lastMessageUserId: null, //Integer
            lastPost: null, //Integer Timestamp
        };
    },

    initialize: function() {
        Model.prototype.initialize.apply(this, arguments);

        this.posts = new ConversationPostsCollection(null, {
            conversation: this,
        });

        this.on('change', function(){
            var type = this.get('type');
            if (type === 'contact') {
                var contact = App.CommunityModule.contactsCollection.get(this.get('referenceId'));
                if (contact) {
                    contact.trigger('change');
                }
            } else if (type === 'group' || type === 'broadcast') {
                var group = App.CommunityModule.groupsCollection.get(this.get('referenceId'));
                if (group) {
                    group.trigger('change');
                }
            }
        }.bind(this));
    },

    customAttributes: {
        activeUsers: function() {
            return _.filter(this.get('users'), {active: true});
        },

        contact: function() {
            var contact = null;
            if (this.get('type') === 'contact') {
                var referenceId = this.get('referenceId');
                contact = App.CommunityModule.contactsCollection.get(referenceId);
            }

            return contact;
        },

        group: function() {
            var group = null;

            if (this.get('type') === 'group' || this.get('type') === 'broadcast') {
                group = App.CommunityModule.groupsCollection.get(this.get('referenceId'));
            }

            return group;
        },

        url: function() {
            var url = '/community/{type}/conversation/' + this.get('id');
            var types = {
                contact: 'contacts',
                group: 'groups',
                broadcast: 'broadcasts',
            };

            return _.tpl(url, {type: types[this.get('type')]});
        },

        name: function() {
            var name = '';
            var contact = this.get('contact');
            var group = this.get('group');

            if (contact) {
                name = contact.get('name') || contact.get('email');
            } else if (group) {
                name = group.get('name');
            }

            return name;
        },
    },

    getUserDataById: function(userId) {
        var conversationUsers = this.get('users');

        return _.findWhere(conversationUsers, {userId: userId});
    },

    getUserNameById: function(userId) {
        var userData = this.getUserDataById(userId);

        return userData.name;
    },
});

module.exports = ConversationModel;